import Vue from "vue";
import Vuex from "vuex";
import swal from "sweetalert2";
import * as fb from "../firebase";
import router from "../router/index";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

Vue.use(Vuex);

// realtime firebase
// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

function catchAlert(title, e, type = "warning") {
    const code = e && e.code ? e.code : "";

    const messages = {
        "auth/invalid-email": "Por favor captura un email válido",
        "auth/wrong-password": "Contraseña inválida",
        "auth/too-many-requests": "Demasiados intentos fallidos, intenta más tarde o recupera tu contraseña",
        "auth/email-already-in-use": "Este correo ya está dado de alta, recupera tu contraseña",
        "auth/user-not-found": "Este usuario no existe en nuestros registros, crea una cuenta",
        "auth/weak-password": "La contraseña debe tener al menos 6 caracteres",
        "auth/network-request-failed": "No se pudo conectar con el servidor. Revisa tu conexión a internet",
    };

    const msg =
        messages[code] || "Hubo un error inesperado, por favor intenta de nuevo";

    swal.fire(title, msg, type);
}

function sendAlert(title, msg, type) {
    swal.fire(title, msg, type);
}

async function saveUserProfile(firebaseUser, form, attempts = 3) {
    const userRef = fb.usersCollection.doc(firebaseUser.uid);
    const userData = {
        user_id: firebaseUser.uid,
        nombre: form.nombre || "",
        apellido: form.apellido || "",
        apellido2: form.apellido2 || "",
        celular: form.celular || "",
        email: firebaseUser.email,
        fecha_nacimiento: form.fecha_nacimiento || "",
        estado: form.estado || "",
        ciudad_o_municipio: form.ciudad_o_municipio || "",
        colonia: form.colonia || "",
        calle: form.calle || "",
        num_ext: form.num_ext || "",
        num_int: form.num_int || "",
        cp: form.cp || "",
        monedero: form.monedero || "",
        club_cinepolis: form.club_cinepolis || "",
        terminos: !!form.terminos,
        created_at: new Date(),
        updated_at: "",
    };

    let lastError = null;

    for (let attempt = 0; attempt < attempts; attempt++) {
        try {
            await userRef.set(userData);

            const savedUser = await userRef.get();
            if (savedUser.exists) {
                return userData;
            }

            throw new Error("No se encontro el perfil guardado en Firestore");
        } catch (e) {
            lastError = e;
        }
    }

    throw lastError || new Error("No se pudo guardar el usuario en Firestore");
}

function custom_sort(a, b) {
    return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
}

const store = new Vuex.Store({
    state: {
        loading: false,
        userProfile: {},
        posts: [],
        ticket: {
            id: null,
            puntos: null,
            time: null,
            time_txt: null,
            ini_time: null,
            fin_time: null,
        },
        tickets: [],
        pregs: [],
    },
    getters: {
        ticketID(state) {
            state.ticket.id = localStorage.getItem(
                "id_ultimo_ticket_veranocinepolis23",
            );
            return state.ticket.id;
        },
        timeInit(state) {
            state.ticket.ini_time = localStorage.getItem(
                "ticket_ini_time_veranocinepolis23",
            );
            return state.ticket.ini_time;
        },
        pregs(state) {
            state.pregs = JSON.parse(localStorage.getItem("pregs"));
            return state.pregs;
        },
    },
    mutations: {
        showLoader(state, val) {
            state.loading = val;
        },
        setUserProfile(state, val) {
            state.userProfile = val;
        },
        setPerformingRequest(state, val) {
            state.performingRequest = val;
        },
        setPosts(state, val) {
            state.posts = val;
        },
        setTicketID(state, val) {
            localStorage.setItem("id_ultimo_ticket_veranocinepolis23", val);
            state.ticket.id = val;
        },
        setTimeInit(state, val) {
            if (
                localStorage.getItem("ticket_ini_time_veranocinepolis23") == null ||
                localStorage.getItem("ticket_ini_time_veranocinepolis23") == ""
            ) {
                localStorage.setItem("ticket_ini_time_veranocinepolis23", val);
                state.ticket.ini_time = val;
            }
        },
        removeTimeInit(state, val = null) {
            localStorage.setItem("ticket_ini_time_veranocinepolis23", "");
            localStorage.setItem("pregs", "");
            state.ticket.ini_time = "";
        },
        setTicket(state, data) {
            state.ticket.puntos = data.puntos;
            state.ticket.time = data.time;
            state.ticket.time_txt = data.time_txt;
        },
        setTickets(state, data) {
            console.log("setting tickets");
            state.tickets = data;
        },
        setPregs(state, data) {
            if (
                localStorage.getItem("pregs") == null ||
                localStorage.getItem("pregs") == ""
            ) {
                localStorage.setItem("pregs", JSON.stringify(data));
                state.pregs = data;
            }
        },
    },
    actions: {
        async signInUser({ dispatch }, { email, password, redirectTo }) {
            dispatch("showLoader", true);

            try {
                const credentials = await fb.auth.signInWithEmailAndPassword(
                    email.trim(),
                    password,
                );

                const firebaseUser = credentials.user;

                if (!firebaseUser) {
                    throw new Error("No se pudo iniciar sesión");
                }

                await dispatch("fetchUserProfile", firebaseUser);

                router.push(redirectTo);

                return firebaseUser;
            } catch (e) {
                console.log({ loginError: e });
                catchAlert("Oops", e, "warning");
                return null;
            } finally {
                dispatch("showLoader", false);
            }
        },
        async login({ dispatch }, form) {
            if (!form.email || !form.password) {
                sendAlert(
                    "Campos requeridos",
                    "Por favor captura tu correo y contraseña",
                    "warning",
                );
                return null;
            }

            return await dispatch("signInUser", {
                email: form.email,
                password: form.password,
                redirectTo: "/dashboard",
            });
        },
        async loginReportes({ dispatch }, form) {
            if (!form.email || !form.password) {
                sendAlert(
                    "Campos requeridos",
                    "Por favor captura tu correo y contraseña",
                    "warning",
                );
                return null;
            }

            return await dispatch("signInUser", {
                email: form.email,
                password: form.password,
                redirectTo: "/reportes/informe",
            });
        },
        async signup({ dispatch }, form) {
            dispatch("showLoader", true);

            try {
                if (!form.email || !form.password) {
                    sendAlert(
                        "Campos requeridos",
                        "Por favor captura tu correo y contraseña",
                        "warning",
                    );
                    return null;
                }

                const credentials = await fb.auth.createUserWithEmailAndPassword(
                    form.email.trim(),
                    form.password,
                );

                const firebaseUser = credentials.user;

                if (!firebaseUser) {
                    throw new Error("No se pudo crear el usuario");
                }

                await saveUserProfile(firebaseUser, form);

                await dispatch("fetchUserProfile", firebaseUser);

                router.push("/dashboard");

                return firebaseUser;
            } catch (e) {
                console.log({ signupError: e });
                catchAlert("Oops", e, "warning");
                return null;
            } finally {
                dispatch("showLoader", false);
            }
        },
        async registroMonedero({ dispatch, commit }, monedero) {
            // sign user up
            dispatch("showLoader", true);

            const userId = fb.auth.currentUser.uid;

            await fb.usersCollection.doc(userId).update({
                monedero: monedero,
                updated_at: new Date(),
            });

            dispatch("fetchUserProfile", { uid: userId });

            dispatch("showLoader", false);

            sendAlert(
                "¡Bien!",
                "Se ha registrado correctamente tu monedero.",
                "success",
            );
            // fetch user profile and set in state
            //dispatch('fetchUserProfile', user.user)
        },
        async fetchUserProfile({ commit }, user) {
            // fetch user profile
            const userProfile = await fb.usersCollection.doc(user.uid).get();
            //console.log({ user: userProfile.data() })
            // set user profile in state
            commit("setUserProfile", userProfile.data());

            // change route to dashboard

            // if (router.currentRoute.path === '/login') {
            //     router.push('/')
            // }
        },
        async logout({ commit }) {
            // log user out
            await fb.auth.signOut();

            // clear user data from state
            commit("setUserProfile", {});

            // redirect to login view
            router.push("/login");
        },
        async logoutReportes({ commit }) {
            // log user out
            await fb.auth.signOut();

            // clear user data from state
            commit("setUserProfile", {});

            // redirect to login view
            router.push("/reportes");
        },
        async createPost({ state, commit }, post) {
            // create post in firebase
            await fb.postsCollection.add({
                createdOn: new Date(),
                content: post.content,
                userId: fb.auth.currentUser.uid,
                userName: state.userProfile.name,
                comments: 0,
                likes: 0,
            });
        },
        async likePost({ commit }, post) {
            const userId = fb.auth.currentUser.uid;
            const docId = `${userId}_${post.id}`;

            // check if user has liked post
            const doc = await fb.likesCollection.doc(docId).get();
            if (doc.exists) {
                return;
            }

            // create post
            await fb.likesCollection.doc(docId).set({
                postId: post.id,
                userId: userId,
            });

            // update post likes count
            fb.postsCollection.doc(post.id).update({
                likes: post.likesCount + 1,
            });
        },
        async updateProfile({ dispatch }, user) {
            const userId = fb.auth.currentUser.uid;
            // update user object
            const userRef = await fb.usersCollection.doc(userId).update({
                name: user.name,
                title: user.title,
            });

            dispatch("fetchUserProfile", { uid: userId });

            // update all posts by user
            const postDocs = await fb.postsCollection
                .where("userId", "==", userId)
                .get();
            postDocs.forEach((doc) => {
                fb.postsCollection.doc(doc.id).update({
                    userName: user.name,
                });
            });

            // update all comments by user
            const commentDocs = await fb.commentsCollection
                .where("userId", "==", userId)
                .get();
            commentDocs.forEach((doc) => {
                fb.commentsCollection.doc(doc.id).update({
                    userName: user.name,
                });
            });
        },
        async registraParticipacion({ dispatch, commit }, data) {
            dispatch("showLoader", true);

            //localStorage.setItem('puntos', puntos)
            //localStorage.setItem('ultimo_tiempo', data.time_txt)

            await dispatch("cierraParticipacion", {
                puntos: data.puntos,
                fecha_fin: new Date(),
                time_txt: data.time_txt,
                time: data.time,
            });

            commit("setTicketID", "");
            commit("removeTimeInit", "");

            dispatch("showLoader", false);

            console.log("redireccionando");

            router.push("/resultado");
        },
        async cierraParticipacion({ dispatch, commit }, data) {
            const userId = fb.auth.currentUser.uid;

            console.log({ "cierra participacion": this.getters.ticketID });
            //console.log(data)

            data.fecha_fin = new Date();
            data.ticketID = this.getters.ticketID;
            data.userId = fb.auth.currentUser.uid;

            //fb.functions.useFunctionsEmulator('http://localhost:5000')

            var cierraParticipacion = fb.functions.httpsCallable(
                "cierraParticipacion",
            );

            await cierraParticipacion(JSON.stringify(data)).then(function(result) {
                // Read result of the Cloud Function.
                console.log({ resultadoFire: result });
                // ...
            });
            console.log("terminó guardado cierra participación");

            //commit('setTicket', data)
        },
        async registroTicket({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            commit("removeTimeInit", "");

            const userId = fb.auth.currentUser.uid;

            console.log(data.file);

            let ticketImgUrl = await dispatch("uploadImage", data.file);

            //PROCESA TICKET EN VERYFI
            //let ticket_ocr = await dispatch("uploadVeryfi", ticketImgUrl);

            console.log("imagen cargada");
            console.log({ imgurl: ticketImgUrl });

            const time = new Date();
            let ticket_obj = {
                created_on: time,
                ticket_img_url: ticketImgUrl,
                user_id: fb.auth.currentUser.uid,
                user_email: fb.auth.currentUser.email,
                no_ticket: "",
                status: "por validar",
                substatus: "",
                cadena: data.cadena,
                sucursal: data.sucursal,
                vendedor: data.vendedor,
                producto: data.producto,
                peso: data.peso,
                boleto: data.boleto,
                ticket_id: data.boleto,
            };

            let ticket = await fb.ticketsCollection.add(ticket_obj);
            console.log({ ticket: ticket });

            console.log(ticket.id);
            commit("setTicketID", ticket.id);

            await fb.usersCollection.doc(userId).update({
                ultimo_ticket_registrado: ticket.id,
                ultimo_ticket_registrado_updated_at: time,
            });

            ticket_obj.id = ticket.id;

            // setTimeout(() => {
            //     router.push("/mis-participaciones/");
            // }, 10000);

            return ticket_obj;
        },
        async actualizaTicketVeryfi({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            console.log({ actualizandoveryfi: data.ticket_obj });

            const userId = fb.auth.currentUser.uid;

            let ticket_ocr = JSON.parse(data.ticket_ocr);

            // let tokens_disponibles = 1;

            // if (data.validacion == "invalido") {
            //     tokens_disponibles = 0;
            // } else if (data.coca_sin_azucar === true) {
            //     tokens_disponibles++;
            // }

            // if (data.socio_plus === true) {
            //     tokens_disponibles = tokens_disponibles * 2;
            // }

            const time = new Date();

            let no_ticket = "NA";
            try {
                //no_ticket = ticket_ocr.document_reference_number;
                no_ticket = ticket_ocr.invoice_number;
            } catch (e) {
                no_ticket = "NA";
            }

            let cadena = "NA";
            try {
                cadena = ticket_ocr.vendor.raw_name;
            } catch (e) {
                cadena = "NA";
            }

            let status = "por validar";
            if (data.validacion == "invalido") {
                status = "invalido";
            }

            let ticket = await fb.ticketsCollection.doc(data.ticket_obj.id).update({
                // tokens: tokens_disponibles,
                // tokens_disponibles: tokens_disponibles,
                no_ticket: no_ticket,
                no_ticket_veryfi: no_ticket,
                created_on_veryfi: time,
                cadena_veryfi: cadena,
                // coca_sin_azucar: data.coca_sin_azucar,
                // cashi: data.cashi,
                status: status,
                boleto: data.boleto || data.ticket_obj.boleto || "pendiente",
                ticket_id: data.boleto || data.ticket_obj.ticket_id || "pendiente",
                ticket_ocr: ticket_ocr,
                validacion: data.validacion,
                //validacion_cementos: data.validacion_cementos,
                validacion_fecha: data.validacion_fecha,
                invoice_duplicado: data.invoice_duplicado,
            });

            dispatch("fetchUserProfile", { uid: userId });

            dispatch("showLoader", false);

            router.push("/mis-participaciones/");

            if (data.validacion == "valido") {
                // sendAlert('¡Ups!', 'El ticket que has registrado es inválido, verifica los datos de tu ticket e intenta subirlo de nuevo, la foto debe ser nítida y contener el ticket completo.', 'warning')
                if (
                    data.coca_sin_azucar === true &&
                    data.cashi === true &&
                    data.socio_plus === true
                ) {
                    return "cocacashiplus";
                } else if (data.coca_sin_azucar === true && data.cashi === true) {
                    return "cocacashi";
                } else if (data.coca_sin_azucar === true && data.socio_plus === true) {
                    return "cocasocioplus";
                } else if (data.socio_plus === true && data.cashi === true) {
                    return "sociopluscashi";
                } else if (data.coca_sin_azucar === true) {
                    return "coca";
                } else if (data.cashi === true) {
                    return "cashi";
                } else if (data.socio_plus === true) {
                    return "socioplus";
                } else {
                    return "ok";
                }
            } else if (data.validacion == "invalido") {
                //router.push("/dinamica");
                return "notok";
            }
        },
        // // // async uploadVeryfi({ dispatch }, img_url) {
        // // //     // File or Blob named mountains.jpg
        // // //     console.log("cargando imagen veryfi");

        // // //     const https = require("https");
        // // //     var qData = {
        // // //         file_name: "",
        // // //         file_data: "",
        // // //         file_url: "",
        // // //         file_urls: [img_url],
        // // //         categories: ["Grocery"],
        // // //         max_pages_to_process: 15,
        // // //         boost_mode: 0,
        // // //         auto_delete: 0,
        // // //         external_id: "123456789",
        // // //         async: 0,
        // // //         parse_address: 1,
        // // //     };
        // // //     this.$http
        // // //         .post(
        // // //             "https://api.veryfi.com/api/v7/partner/documents",
        // // //             JSON.stringify(qData), {
        // // //                 emulateJSON: true,
        // // //                 httpsAgent: new https.Agent({ rejectUnauthorized: false }),
        // // //                 headers: {
        // // //                     "Content-Type": "application/json",
        // // //                     "CLIENT-ID": "",
        // // //                     Authorization: "apikey :",
        // // //                 },
        // // //             }
        // // //         )
        // // //         .then(
        // // //             (response) => {
        // // //                 // get body data
        // // //                 console.log("VERYFI RESPONSE");
        // // //                 console.log(response);
        // // //                 return response;
        // // //             },
        // // //             (error) => {
        // // //                 // error callback
        // // //                 console.log("error callback");
        // // //                 console.log(error);
        // // //                 return { "error": error };
        // // //             }
        // // //         );
        // // // },

        async registraTrivia({ dispatch, commit }, data) {
            dispatch("showLoader", true);

            //localStorage.setItem('puntos', puntos)
            //localStorage.setItem('ultimo_tiempo', data.time_txt)

            await dispatch("cierraParticipacion", {
                puntos: data.puntos,
                fecha_fin: new Date(),
                time_txt: data.time_txt,
                time: data.time,
                respuestas: data.respuestas,
                week: moment().week(),
            });

            commit("setTicketID", "");
            commit("removeTimeInit", "");

            dispatch("showLoader", false);

            console.log("redireccionando");

            router.push("/resultado");
        },

        async uploadImage({ dispatch }, file) {
            // File or Blob named mountains.jpg
            console.log("cargando imagen");
            const userId = fb.auth.currentUser.uid;
            const idImagen = uuidv4();
            const nombreImagen =
                userId + "-" + idImagen + "." + file.name.split(".").pop();

            const storageRef = fb.storage.ref(`tickets/${nombreImagen}`).put(file);

            let promesa = null;
            promesa = () => {
                return new Promise((resolve, reject) => {
                    storageRef.on(
                        "state_changed",
                        (snapshot) => {
                            //this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
                        },
                        (error) => {
                            console.log(error.message);
                            reject(error.message);
                        },
                        () => {
                            storageRef.snapshot.ref.getDownloadURL().then((url) => {
                                //console.log({ url: url })
                                resolve(url);
                                //this.picture =url;
                            });
                        },
                    );
                });
            };

            let downloadUrl = null;
            try {
                downloadUrl = await promesa();
            } catch (err) {
                console.log(err);
                return null;
            }

            console.log({ termino: downloadUrl });
            //dispatch('setImgUrl', downloadUrl)

            return downloadUrl;
        },
        showLoader({ commit }, val) {
            commit("showLoader", val);
        },
        async getTickets({ dispatch, commit }) {
            dispatch("showLoader", true);
            console.log("getTickets");

            const userId = fb.auth.currentUser.uid;
            let tickets = null;
            try {
                let promesa = null;
                promesa = () => {
                    return new Promise((resolve, reject) => {
                        fb.ticketsCollection
                            .where("user_id", "==", userId)
                            .where("status", "in", ["cerrado", "por validar"])
                            .onSnapshot((snapshot) => {
                                let postsArray = [];

                                snapshot.forEach((doc) => {
                                    let post = doc.data();
                                    post.id = doc.id;
                                    postsArray.push(post);
                                });

                                postsArray.sort(custom_sort);
                                console.log({ tickets_: postsArray });
                                store.commit("setTickets", postsArray);
                                resolve(postsArray);
                            });
                    });
                };

                tickets = await promesa();
                console.log("set already");
            } catch (err) {
                console.log(err);
            }

            dispatch("showLoader", false);
            return tickets;
        },
        async setTimeInit({ commit }) {
            const data = {
                init_time: new Date(),
                ticketID: this.getters.ticketID,
            };

            //fb.functions.useFunctionsEmulator('http://localhost:5000')
            var comienzaParticipacion = fb.functions.httpsCallable(
                "comienzaParticipacion",
            );

            let res = null;
            await comienzaParticipacion(JSON.stringify(data)).then(function(result) {
                // Read result of the Cloud Function.
                console.log({ resultadoFire: result });
                res = result;
                // ...
            });
            console.log("comienza participación");
            console.log(res);
            if (res.data.status == "notok" && res.data.time_init != "") {
                data.init_time = new Date(res.data.time_init);
            }

            commit("setTimeInit", data.init_time);
        },

        async revisarSemanaTicketsUsuario({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            const userId = data.userId;
            const ticketsSemana = await fb.ticketsCollection
                .where("user_id", "==", userId)
                .where("week", "==", moment().week())
                .where("status", "==", "cerrado")
                .get();

            let puntos_a_sumar = 100;

            console.log({ tickets_semana: ticketsSemana.length });

            if (ticketsSemana.length > 1) {
                puntos_a_sumar = 500;
            }

            dispatch("showLoader", false);

            return puntos_a_sumar;
        },
        async actualizaTicketAdmin({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            console.log({ actualizandoveryfi: data.ticket_obj });

            const userId = fb.auth.currentUser.uid;

            const time = new Date();

            let ticket = await fb.ticketsCollection.doc(data.ticket_obj.id).update({
                cadena: data.ticket_obj.cadena,
                sucursal: data.ticket_obj.sucursal,
                vendedor: data.ticket_obj.vendedor,
                producto: data.ticket_obj.producto,
                peso: data.ticket_obj.peso,
                cantidad: data.ticket_obj.cantidad,
                "ticket_ocr.date": data.ticket_obj.ticket_ocr.date,
            });

            dispatch("showLoader", false);

            router.push("/reportes/informe");
        },
        async actualizarCodigoTicketDulceria({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizaTicket: data });

            const userId = data.userId;
            const ticketAbierto = await fb.ticketsCollection.doc(data.id).get();

            console.log(ticketAbierto);

            if (ticketAbierto.exists) {
                console.log({ ticketAbierto: ticketAbierto.data() });
                let ticket_data = ticketAbierto.data();
                let puntos_totales =
                    parseInt(ticket_data.puntos) + parseInt(data.puntos);

                await fb.ticketsCollection.doc(ticketAbierto.id).update({
                    codigo_updated_at: new Date(),
                    codigo_dulceria: data.codigo,
                    status: "cerrado",
                    tipo_cupon: data.tipo_cupon,
                    puntos_acumulados: parseInt(data.puntos),
                    puntos_totales: puntos_totales,
                });

                //acumular puntos para usuario
                // // // let user = await fb.usersCollection.doc(userId).get();
                // // // if (user.exists) {
                // // //     console.log({ user: user.data() })
                // // //     let user_data = user.data()
                // // //     let puntos_acumulados = parseInt(user_data.puntos_acumulados) + parseInt(data.puntos);

                // // //     await fb.usersCollection.doc(userId).update({
                // // //         puntos_acumulados: puntos_acumulados
                // // //     })

                // // // }
            } else {
                dispatch("showLoader", false);
                return false;
            }

            return true;
        },
        async changeStatusTicketValidacion({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizaTicket: data });

            try {
                await fb.ticketsCollection.doc(data.ticket_id).update({
                    validacion_updated_at: new Date(),
                    status: data.status,
                    boleto: data.boleto,
                    ticket_id: data.boleto,
                });

                return true;
            } finally {
                dispatch("showLoader", false);
            }
        },

        async changeSubStatusTicketValidacion({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizaTicket: data });

            await fb.ticketsCollection.doc(data.ticket_id).update({
                validacion_substatus_updated_at: new Date(),
                substatus: data.status,
            });

            dispatch("showLoader", false);

            return true;
        },

        async changeStatusMembresiaValidacion({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizaTicket: data });

            let tokens = null;
            if (data.status == "valida") {
                const ticket = await fb.ticketsCollection.doc(data.ticket_id).get();

                console.log(ticket);

                if (ticket.exists) {
                    console.log({ ticketmembresia: ticket.data() });
                    let ticket_data = ticket.data();

                    //tokens = parseInt(ticket_data.tokens_disponibles) * 2;
                }

                await fb.ticketsCollection.doc(data.ticket_id).update({
                    validacion_updated_at: new Date(),
                    status_membresia: data.status,
                    //tokens_disponibles: tokens,
                });
            } else {
                await fb.ticketsCollection.doc(data.ticket_id).update({
                    validacion_updated_at: new Date(),
                    status_membresia: data.status,
                });
            }

            dispatch("showLoader", false);

            return true;
        },
        async actualizarCodigoNoValido({ dispatch, commit }, data) {
            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch("showLoader", true);

            console.log({ actualizacodigonovalido: data });

            const userId = data.userId;
            const ticketAbierto = await fb.ticketsCollection.doc(data.id).get();

            console.log(ticketAbierto);

            if (ticketAbierto.exists) {
                console.log({ ticketAbierto: ticketAbierto.data() });
                let ticket_data = ticketAbierto.data();

                await fb.ticketsCollection.doc(ticketAbierto.id).update({
                    status: "cerrado",
                    tipo_cupon: data.tipo_cupon,
                    puntos_acumulados: 0,
                    puntos_totales: 0,
                });

                //acumular puntos para usuario
                let user = await fb.usersCollection.doc(userId).get();
                if (user.exists) {
                    console.log({ user: user.data() });
                    let user_data = user.data();
                    let puntos_acumulados =
                        parseInt(user_data.puntos_acumulados) + parseInt(data.puntos);

                    await fb.usersCollection.doc(userId).update({
                        puntos_acumulados: puntos_acumulados,
                    });
                }
            } else {
                dispatch("showLoader", false);
                return false;
            }

            return true;
        },
    },
});

export default store;
